import format from 'date-fns/format'
import {AmplifyTheme} from "aws-amplify-react";

export const convertDollarsToCents = price => (price*100).toFixed(0) 
export const convertCentsToDollar = price => (price/100).toFixed(2)
export const round2 = (num) => Math.round(num * 100 + Number.EPSILON) / 100; // 123.2345 => 123.23

export const getCategory = (product) => {
  if (product && product.category && product.category.trim()) {
    return product.category.trim();
  }
  const desc = ((product && product.description) || '').toLowerCase();
  if (/coffee|tea|milk|juice|soda|drink|beverage/i.test(desc)) return 'Beverages';
  if (/spice|masala|turmeric|chilli|pepper|cumin|powder|cardamom|clove/i.test(desc)) return 'Spices & Masalas';
  if (/rice|dal|lentil|flour|atta|urad|moong|chana|basmati|poha/i.test(desc)) return 'Grains & Dal';
  if (/snack|chip|mixture|murukku|biscuit|namkeen|sweet|ladoo|halwa/i.test(desc)) return 'Snacks & Sweets';
  if (/frozen|paratha|paneer|ice|roti|dosa|idli/i.test(desc)) return 'Frozen & Dairy';
  return 'Pantry & Groceries';
};

export const  convertPricetoNum = price => {
    if (Number.isNaN(Number.parseFloat(price))) {
      return 0;
    }
    return parseFloat(price);
  }
export const formatNumber = number => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(convertCentsToDollar (number));
}

export const formatProductDate = date => format(date, 'MMM Do, YYYY')
export const formatOrderDate = date => format(date, 'ddd h:mm A, MMM Do, YYYY')


export const isAuthenticated = (user ) => {
  if (!user ) {
      return false;
  } else { 
    return true;  
  }
};

export const theme = {
  ...AmplifyTheme,

  // outer wrapper: give the form breathing room and center it on every size
  container: {
    ...AmplifyTheme.container,
    padding: '24px 16px',
    boxSizing: 'border-box',
  },

  // fluid width — fills small phones, capped and centered on desktop
  formContainer: {
    ...AmplifyTheme.formContainer,
    margin: '0 auto',
    width: '100%',
    maxWidth: '420px',
    padding: '0 16px',
    boxSizing: 'border-box',
  },
  formSection: {
    ...AmplifyTheme.formSection,
    width: '100%',
    maxWidth: '420px',
    margin: '0 auto',
    padding: '28px',
    borderRadius: '16px',
    boxSizing: 'border-box',
    boxShadow: '0 10px 26px rgba(31, 45, 61, 0.08)',
  },

  sectionHeader: {
    ...AmplifyTheme.sectionHeader,
    color: '#1f2d3d',
    fontWeight: 700,
  },

  // inputs must be full-width + border-box so they never overflow the card
  input: {
    ...AmplifyTheme.input,
    width: '100%',
    boxSizing: 'border-box',
    borderRadius: '10px',
    padding: '12px 14px',
  },

  // on-brand green instead of the old pink
  button: {
    ...AmplifyTheme.button,
    backgroundColor: '#01bf71',
    borderRadius: '10px',
  },
  navBar: {
    ...AmplifyTheme.navBar,
    backgroundColor: '#ffffff',
  },
  a: {
    ...AmplifyTheme.a,
    color: '#01bf71',
  },
};